import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { getPasswordResetToken } from '../services/operations/authApi';
import { BsArrowLeft } from 'react-icons/bs';
import ConfirmationModal from '../components/common/ConfirmationModal'

const ForgotPassword = () => {
    const [emailSent, setEmailSent] = useState(false);
    const [email, setEmail] = useState('');
    const [confirmationModal, setConfirmationModal] = useState(null);
    const dispatch = useDispatch();
    const handleOnSubmit = (event) => {
        event.preventDefault();
        dispatch(getPasswordResetToken(email, setEmailSent, setConfirmationModal));
    }

    return (
        <div className='mt-14'>
            <div className='flex justify-center items-center relative md:top-[8rem]'>
                <div className='text-richblack-5 w-[30rem] h-[40rem] p-[2rem]'>
                    <h1 className='text-3xl font-semibold my-3'>
                        {!emailSent ? 'Reset Your Password' : "Check Your Email"}
                    </h1>
                    <p className='text-lg text-richblack-100 my-3'>
                        {!emailSent ? "Explore our password recovery options to regain access to your account. We'll send you a secure link via email to reset your password."
                            : `We have sent the reset password email to ${email}`
                        }
                    </p>
                    <form onSubmit={handleOnSubmit} className='flex flex-col my-3'>
                        {!emailSent &&
                            <label>
                                <p className='my-3'>Email Address <sup className='text-pink-200'>*</sup></p>
                                <input className='bg-richblack-800 shadow-[0px_2px_0px_0px_rgba(255,255,255,0.18)] w-full text-lg p-3 rounded-md my-3 outline-none' required type='email' name='email' value={email} onChange={(e) => setEmail(e.target.value)} placeholder='Enter Email' />
                            </label>
                        }
                        <div className='my-6'>
                            <button type='submit' className='w-full font-bold shadow-[2px_2px_0px_0px_rgba(255,255,255,0.18)] text-[17px] px-6 py-3 rounded-md bg-yellow-50 text-black hover:shadow-transparent hover:scale-95 transition-all duration-200'>
                                {
                                    !emailSent ? 'Reset Password' : 'Resend Link'
                                }
                            </button>
                        </div>
                    </form>
                    <div className='mx-5'>
                        <Link to={'/login'}>
                            <p className='flex items-center gap-2'><span><BsArrowLeft /></span>Back to Login</p>
                        </Link>
                    </div>
                </div>
            </div>
            {confirmationModal && <ConfirmationModal modalData={confirmationModal} />}
        </div>
    )
}

export default ForgotPassword;